export default function CTASection({
  title,
  description,
  buttonText = "Get Started Now",
  buttonLink,
}) {
  return (
    <section className="w-full bg-[#000D83]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-center px-6 py-20 text-center">
        <h2 className="text-3xl font-bold text-white md:text-5xl">{title}</h2>

        <p className="mt-6 max-w-2xl text-sm leading-7 text-blue-100 md:text-base">
          {description}
        </p>

        <div className="mt-10 flex w-full items-center justify-center sm:w-auto">
          <a
            href={buttonLink}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-xl bg-[#E17A01] px-8 py-3 font-semibold text-white transition hover:bg-[#9c580c]"
          >
            {buttonText}
          </a>
        </div>
      </div>
    </section>
  );
}
